import type { Address } from 'viem'

import type { InKindRedemptionEntrySource } from '../events'
import { trackAnalyticsEvent } from '../track'

export interface InKindRedemptionEntryParams {
  source: InKindRedemptionEntrySource
  chainId: number
  vaultAddress: Address
}

const buildProperties = (params: InKindRedemptionEntryParams) => ({
  source: params.source,
  chain_id: params.chainId,
  vault_address: params.vaultAddress.toLowerCase()
})

export function trackInKindRedemptionEntryViewed(params: InKindRedemptionEntryParams) {
  trackAnalyticsEvent('in_kind_redemption_entry_viewed', buildProperties(params))
}

export function trackInKindRedemptionEntryClicked(params: InKindRedemptionEntryParams) {
  trackAnalyticsEvent('in_kind_redemption_entry_clicked', buildProperties(params))
}
